import React from 'react'
import { Link } from 'react-router-dom'
import './style.css'

export default function UserProfile() {

   return (
      <div className="user-profile-container">
         <Link to='/myduonuts' className='btn btn-secondary' >
            My Duonuts
         </Link>
         <img src='/assets/user.png' />
      </div>
   )
}
